var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable */
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import videojs from 'video.js';
import { css, StyleSheet } from 'aphrodite';
import { bind } from 'bind-decorator';
import { observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { isMobileSafari, isiOSApp } from '../../../util';
const FullScreenButton = observer(class FullScreenButton extends React.Component {
    render() {
        const img = this.props.vm.isFullScreen ? 'fullscreen_off.svg' : 'fullscreen_on.svg';
        return (React.createElement("div", { className: css(styles.wrapper) },
            React.createElement("img", { src: `/assets/images/video/${img}`, className: css(styles.image) })));
    }
});
class VjsFullScreenButtonVM {
    constructor() {
        Object.defineProperty(this, "isFullScreen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        makeObservable(this, {
            isFullScreen: observable,
        });
    }
}
export default class VjsFullScreenButton extends videojs.getComponent('FullscreenToggle') {
    constructor(player, options) {
        super(player, options);
        Object.defineProperty(this, "fullScreenButtonPlayer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "vm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this.fullScreenButtonPlayer = player;
        this.vm = new VjsFullScreenButtonVM();
        this.mount = this.mount.bind(this);
        this.fullScreenButtonPlayer.ready(() => {
            this.mount();
        });
    }
    handleFullscreenChange(e) {
        // @ts-ignore FullscreenToggle のフルスクリーン切り替えAPIをコール
        super.handleFullscreenChange(e);
        // HACK: iOS Safari は Fullscreen API が非対応でiOS独自のフルスクリーンが展開されるためアイコンの状態は変化させない
        if (isMobileSafari() || isiOSApp()) {
            return;
        }
        const sideSuper = this.fullScreenButtonPlayer.getChild('VjsVideoSideSuper');
        if (sideSuper) {
            sideSuper.vm.setIsFullScreen(!this.vm.isFullScreen);
        }
        const controller = this.fullScreenButtonPlayer.getChild('VjsVideoController');
        controller.vm.setIsFullScreen(!this.vm.isFullScreen);
        // 完了ボタンはフルスクリーンボタンの上に配置しているため、位置切り替えのために状態を伝える
        const completeButton = this.fullScreenButtonPlayer.getChild('VjsCompleteButton');
        if (completeButton) {
            completeButton.vm.setIsFullScreen(!this.vm.isFullScreen);
        }
        this.vm.isFullScreen = !this.vm.isFullScreen;
    }
    mount() {
        const root = ReactDOM.createRoot(this.el());
        root.render(React.createElement(FullScreenButton, { vm: this.vm }));
    }
}
__decorate([
    bind
], VjsFullScreenButton.prototype, "handleFullscreenChange", null);
const styles = StyleSheet.create({
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        marginTop: '2vh',
        marginRight: 4,
        outline: 'none',
    },
    image: {
        width: 20,
    },
});
